@if (screenSize() === "desktop" || screenSize() === "tablet") {
  <nav class="nav-bar">
    <button routerLink="" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
      Home
    </button>
    @if (userRole() === Role.REGISTERED) {
      <button [matMenuTriggerFor]="admin_changes">
        Administrative Changes
        <mat-icon aria-hidden="false" aria-label="Admin changes menu" fontIcon="arrow_drop_down"/>
      </button>
      <button [matMenuTriggerFor]="reporting">
        Reporting
        <mat-icon aria-hidden="false" aria-label="Admin changes menu" fontIcon="arrow_drop_down"/>
      </button>
    } @else if (userRole() === Role.UNREGISTERED || userRole() === Role.DEREGISTERED) {
      <button [matMenuTriggerFor]="unregistered_user_actions">
        Reporting
        <mat-icon aria-hidden="false" aria-label="Admin changes menu" fontIcon="arrow_drop_down"/>
      </button>
    }
  </nav>
} @else {
  <nav class="nav-mobile-left">
    <button mat-icon-button [matMenuTriggerFor]="mobileNavMenu">
      <mat-icon aria-hidden="false" aria-label="Menu" fontIcon="view_headline"></mat-icon>
    </button>
  </nav>

  <mat-menu #mobileNavMenu>
    <button mat-menu-item routerLink="">
      Home
    </button>
    @if (userRole() === Role.REGISTERED) {
      <button mat-menu-item [matMenuTriggerFor]="admin_changes">
        Administrative Changes
      </button>
      <button mat-menu-item [matMenuTriggerFor]="reporting">
        Reporting
      </button>
    } @else if (userRole()=== Role.UNREGISTERED || userRole() === Role.DEREGISTERED) {
      <button mat-menu-item [matMenuTriggerFor]="unregistered_user_actions">
        Reporting
      </button>
    }
    <button mat-menu-item (click)="authService.logout()">
      Logout
    </button>

    <div class="nav-login-info-container card">
      <table>
        <tr>
          <th>Facility Registration Number</th>
          <td>{{userService.activeFacility()?.registrationNumber}}</td>
        </tr>

        <tr>
          <th>Facility Name</th>
          <td>{{userService.activeFacility()?.name}}</td>
        </tr>

        <tr>
          <th>Facility Registration Status</th>
          <td>{{userService.activeFacility()?.registrationStatus?.value}}</td>
        </tr>

        <tr>
          <th>Entity Name</th>
          <td>{{userService.activeFacility()?.entity?.name}}</td>
        </tr>

        @if(userService.facilities() && userService.facilities()?.length! > 1) {
          <button class="change-facility" mat-flat-button (click)="userService.openFacilityDialog()">Change Facility</button>
        }
      </table>
    </div>
  </mat-menu>
}

<!-- Menu templates -->
<mat-menu #admin_changes>
  <button mat-menu-item routerLink="change-responsible-officer">
    Change Responsible Officer Details
  </button>
  <button mat-menu-item routerLink="change-of-purpose">
    Change of Purpose
  </button>
  <button mat-menu-item routerLink="start-to-handle-new-ssba">
    Start to Handle New SSBA
  </button>
  <button mat-menu-item routerLink="change-of-entity-and-facility-details">
    Change of Entity and Facility Details
  </button>
</mat-menu>

<mat-menu #reporting>
  <button mat-menu-item routerLink="incident">
    Incident
  </button>
  <button mat-menu-item routerLink="transfers-in">
    Transfers In
  </button>
  <button mat-menu-item routerLink="transfers-out">
    Transfers Out
  </button>
  <button mat-menu-item routerLink="destruction-of-an-ssba">
    Destruction of an SSBA
  </button>
  <button mat-menu-item routerLink="application-for-extension">
    Application for Extension
  </button>
  <button mat-menu-item routerLink="suspected-ssba-registered">
    Suspected SSBAs
  </button>
  <button mat-menu-item routerLink="temporary-handling">
    Temporary Handling or Disposal of an SSBA
  </button>
  <button mat-menu-item routerLink="transfer-between-facilities-of-the-same-entity">
    Transfer Between Facilities of the Same Entity
  </button>
  <button mat-menu-item routerLink="registration-of-a-linked-storage-unit">
    Registration of a Linked Storage Unit
  </button>
  <button mat-menu-item routerLink="removal-of-a-linked-storage-unit">
    Removal of a Linked Storage Unit
  </button>
</mat-menu>

<mat-menu #unregistered_user_actions>
  <button mat-menu-item routerLink="suspected-ssba-non-registered">
    Suspected SSBAs and Confirmatory Testing Results
  </button>
  <button mat-menu-item routerLink="temporary-handling">
    Temporary Handling or Disposal of an SSBA
  </button>
</mat-menu>
